import { render } from "./AprilFoolCardModal.vue?vue&type=template&id=052095ad&scoped=true&ts=true&lang=pug"
import script from "./AprilFoolCardModal.vue?vue&type=script&lang=ts"
export * from "./AprilFoolCardModal.vue?vue&type=script&lang=ts"

import "./AprilFoolCardModal.vue?vue&type=style&index=0&id=052095ad&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052095ad"]])

export default __exports__